let showCartDrawer = document.querySelector(".show-cart-drawer");
let addToCartButton = document.querySelector(".add-to-cart-button");
let cartDrawer = document.querySelector(".cart-drawer");
let cartCloseButton = cartDrawer.querySelector(".cart-close-button");
let cartOverlay = cartDrawer.querySelector(".cart-overlay");
let quickBuyButtons = document.querySelectorAll(".quick-buy-button");

quickBuyButtons.forEach((button) => {
  button.addEventListener("click", function () {
    let variantID = this.getAttribute("data-variant-id");

    addItemToCart(variantID, 1);
  });
});

cartCloseButton.addEventListener("click", function () {
  cartDrawer.classList.add("hidden");
  document.querySelector("body").classList.remove("overflow-hidden");
});

cartOverlay.addEventListener("click", function () {
  cartDrawer.classList.add("hidden");
  document.querySelector("body").classList.remove("overflow-hidden");
});

showCartDrawer.addEventListener("click", function () {
  initCart();
});

addToCartButton?.addEventListener("click", function () {
  let variantID = document.querySelector('input[name="variant"]:checked')?.value;
  let quantity = document.querySelector(".product-qty")?.value || 1;
  console.log(quantity);
  addItemToCart(variantID, quantity);
});

function initCart() {
  cartDrawer.classList.remove("hidden");
  document.querySelector("body").classList.add("overflow-hidden");

  fetch("/cart.js")
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      renderCart(data);
    })
    .catch((error) => {
      alert("Error: " + error.message);
    });
}
function renderCart(data) {
  let cartDrawer = document.querySelector(".cart-drawer");
  let cartContainer = document.querySelector(".cart-container");
  let cartCount = cartDrawer.querySelector(".cart-count");
  let cartTotal = cartDrawer.querySelector(".cart-total");
  let cartFooter = cartDrawer.querySelector(".cart-footer");
  let emptyCartContainer = cartDrawer.querySelector(".empty-cart-container");

  if (data.item_count === 0) {
    emptyCartContainer.classList.remove("hidden");
    cartContainer.classList.add("hidden");
    cartFooter.classList.add("hidden");
  } else {
    emptyCartContainer.classList.add("hidden");
    cartContainer.classList.remove("hidden");
    cartFooter.classList.remove("hidden");
  }

  if (data.item_count === 1) {
    cartCount.textContent = `${data.item_count} Item`;
  } else {
    cartCount.textContent = `${data.item_count} Items`;
  }

  cartTotal.textContent = `$${(data.total_price / 100).toFixed(2)}`;

  cartContainer.innerHTML = ""; // Clear previous content
  if (data.items.length === 0) {
    cartContainer.innerHTML = "<p>Your cart is empty.</p>";
    return;
  }

  if (data.item_count > 0) {
    data.items.forEach((item) => {
      let itemElement = document.createElement("div");
      itemElement.classList.add("cart-item");
      itemElement.innerHTML = `
        <div class="cart-item border border-grey-border rounded-md p-2 md:p-4 flex gap-3 md:gap-4 relative">
          <div class="flex-shrink-0">
              <a href="${item.url}">
                <img 
                  src="${item.image}" 
                  alt="${item.product_title}" 
                  class="w-20 md:w-[120px] aspect-square object-cover rounded"
                />
              </a>
          </div>
          <div class="flex flex-col flex-1">
            <a 
              href="${item.url}" 
              class="text-primary-dark font-semibold leading-[1.2] text-[12px] md:text-[16px] pr-10"
            >
              ${item.product_title}
            </a>
              
          <div class="flex justify-between mt-auto mb-0">
            <div class="border-grey-border border rounded-md h-[28px] md:h-[40px] w-[110px] flex items-center p-1.5 md:p-3">
              <button class="qty-minus flex-shrink-0" data-id="${item.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M4 8H12.4853" stroke="#11274A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
              <input 
                type="text" 
                readonly 
                value="${item.quantity}" 
                class="w-full text-center text-primary-dark text-sm font-bold bg-white cart-product-qty appearance-none [-webkit-appearance:none]"
              >
              <button class="qty-plus flex-shrink-0" data-id="${item.id}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M7.53553 4.46447V11.5355M4 8H11.0711" stroke="#11274A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
              </button>
            </div>
              
            <div class="mt-auto mb-0">
              <p class="font-manrope text-[12px] font-semibold leading-[1.2] text-primary-dark md:text-[16px]">
                $${(item.price / 100).toFixed(2)}
              </p>
            </div>
          </div> 
          <button class="delete-product-from-cart absolute top-2 right-2 md:top-4 md:right-4" data-id="${
            item.id
          }">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 3.99992H3.33333M3.33333 3.99992H14M3.33333 3.99992L3.33333 13.3333C3.33333 13.6869 3.47381 14.026 3.72386 14.2761C3.97391 14.5261 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5261 12.2761 14.2761C12.5262 14.026 12.6667 13.6869 12.6667 13.3333V3.99992M5.33333 3.99992V2.66659C5.33333 2.31296 5.47381 1.97382 5.72386 1.72378C5.97391 1.47373 6.31304 1.33325 6.66667 1.33325H9.33333C9.68696 1.33325 10.0261 1.47373 10.2761 1.72378C10.5262 1.97382 10.6667 2.31296 10.6667 2.66659V3.99992" stroke="#707070" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        </div>
      `;
      cartContainer.appendChild(itemElement);

      // ----- Init delete product -----
      let deleteBtn = itemElement.querySelector(".delete-product-from-cart");
      deleteBtn.addEventListener("click", function () {
        const variantId = this.getAttribute("data-id");
        deleteProductFromCart(variantId);
      });

      // ----- Init qty minus -----
      let minusBtn = itemElement.querySelector(".qty-minus");
      let plusBtn = itemElement.querySelector(".qty-plus");
      let qtyInput = itemElement.querySelector(".cart-product-qty");

      minusBtn.addEventListener("click", function () {
        let currentQty = parseInt(qtyInput.value, 10);
        if (currentQty > 1) {
          updateProductQuantity(item.id, currentQty - 1);
        }
      });

      plusBtn.addEventListener("click", function () {
        let currentQty = parseInt(qtyInput.value, 10);
        updateProductQuantity(item.id, currentQty + 1);
      });
    });
  }
}

function updateProductQuantity(variantId, newQty) {
  let data = {
    id: variantId,
    quantity: newQty,
  };

  postAjax("/cart/change.js", data, function (data) {
    initCart();
  });
}
function deleteProductFromCart(variantId, callback) {
  let data = {
    id: variantId,
    quantity: 0,
  };

  postAjax("/cart/change.js", data, function (response) {
    if (callback) callback();
    initCart();
  });
}

function addItemToCart(variant_id, qty) {
  let data = {
    id: variant_id,
    quantity: Number(qty),
  };

  postAjax("/cart/add.js", data, function (response) {
    initCart();
  });
}

function postAjax(url, data, success) {
  var params =
    typeof data == "string"
      ? data
      : Object.keys(data)
          .map(function (k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
          })
          .join("&");

  var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
  xhr.open("POST", url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState > 3 && xhr.status == 200) {
      success(xhr.responseText);
    }
  };
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.send(params);
  return xhr;
}

window.CartApi = {
  updateProductQuantity,
  updateProductQuantity,
  deleteProductFromCart: deleteProductFromCart,
  addItemToCart: addItemToCart,
};
